import { useQuery } from "react-query";
import type { InterfaceLanguageCode } from "src/app/consts/AvailableLanguages";
import type { LanguageFile } from "src/shared/i18n/LanguageFile";

export const useLanguage = (languageCode: InterfaceLanguageCode) => {
  return useQuery<LanguageFile>(
    ["language", languageCode],
    async () => (await import(`src/shared/i18n/${languageCode}`)).default,
  );
};
